import apiClient from './apiClient';

// Διαχείριση λογαριασμών και καθολικών ρόλων (Πίνακας 1, `user:manage`).
//
// **Νέο άρθρωμα και όχι προσθήκη στον υπάρχοντα μεταφορέα**, κατά τον κανόνα των
// παράλληλων κλάδων: νέο αρχείο δεν συγκρούεται ποτέ σε συγχώνευση, ενώ δύο κλάδοι
// που προσθέτουν μεθόδους στο ίδιο αντικείμενο συγκρούονται σε κάθε μία.
//
// Ο φράχτης είναι **αποκλειστικά ο εξυπηρετητής**: ολόκληρος ο δρομολογητής των
// χρηστών απαιτεί διαχειριστή. Η απόκρυψη της εγγραφής από το μενού είναι
// ευχρηστία, όχι ασφάλεια — το ίδιο σκεπτικό με την οθόνη των κλειδιών.

/**
 * ΛΑ-02 / Πίνακας 1: ο κατάλογος των λογαριασμών.
 *
 * Αναζήτηση και σελιδοποίηση **στον διακομιστή**. Ο πελάτης δεν φιλτράρει τα
 * φορτωμένα: με σελιδοποίηση, φιλτράρισμα στον πελάτη ψεύδεται για το εύρος του —
 * ο χρήστης που δεν βρίσκει κάποιον δεν μαθαίνει αν λείπει ή αν είναι στη σελίδα 3.
 */
function getUsers({ page = 1, q = '' } = {}) {
    const params = new URLSearchParams();
    params.set('page', String(page));
    if (q.trim()) params.set('q', q.trim());

    return apiClient.getPage(`/api/users?${params.toString()}`);
}

/**
 * Προαγωγή ή υποβιβασμός καθολικού ρόλου.
 *
 * **Καμία εκπομπή γεγονότος από εδώ**: τα `user.promoted` και `user.demoted`
 * εκπέμπονται ήδη από τον εξυπηρετητή, στη μεταβολή και μόνο σε αυτήν. Ο πελάτης
 * καλεί· δεν αφηγείται.
 *
 * **Και κανένας κανόνας δεν αντιγράφεται εδώ.** Ποιος επιτρέπεται να υποβιβαστεί
 * —όχι ο εαυτός, όχι ο τελευταίος— κρίνεται στο API κατά το §4.4. Η οθόνη
 * αποκρύπτει την ενέργεια όπου δεν έχει νόημα και **εμφανίζει την άρνηση** όπου
 * έρθει· δεν προσπαθεί να την προβλέψει.
 */
function setAdmin(userId, isAdmin) {
    return apiClient.patch(`/api/users/${userId}`, { isAdmin });
}

export const usersService = { getUsers, setAdmin };

export default usersService;
